(function () {
  'use strict';
  angular.module('providerPortal')
    .run(['$state', '$rootScope', function ($state, $rootScope) {
      $rootScope.$state = $state;
    }])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
      $urlRouterProvider.otherwise("/");
      $stateProvider
        .state('main', {
          templateUrl: 'js/main.html' + appVersion
        })
        .state('root', {
          url: '/',
          templateUrl: 'js/security/login.html' + appVersion,
          params: {allParams: {}},
          parent: 'main'
        })
        .state('createUser', {
          url: '/createUser',
          templateUrl: 'js/registration/createUser.html' + appVersion,
          parent: 'main'
        })
        .state('registration', {
          url: '/registration',
          templateUrl: 'js/registration/createAccount.html' + appVersion,
          parent: 'main'
        })
        .state('registration.nonDso', {
          url: '/nonDso',
          templateUrl: 'js/registration/registration.html' + appVersion
        })
        .state('confirmation', {
          url: '/confirmation',
          templateUrl: 'js/registration/confirmation.html' + appVersion,
          parent: 'main'
        })
        .state('verifyEmail', {
          url: '/verifyEmail?id&guid',
          template:'',
          controller: 'verifyEmailController',
          parent: 'main'
        })
        .state('registerDso', {
          url:'/createDsoPortalUser?id&guid&type',
          templateUrl: 'js/registration/registration.html' + appVersion,
          parent: 'main'
        })
        .state('forgotUserId', {
          url: '/forgotUserId',
          templateUrl: 'js/forgotUser/forgotUserId.html' + appVersion,
          parent: 'main'
        })
        .state('forgotUserIdConfirmation', {
          url:'/forgotUserConfirmation',
          templateUrl: 'js/forgotUser/forgotUserIdConfirmation.html' + appVersion,
          params: {response: {}},
          parent: 'main'
        })
        .state('forgotPassword', {
          url: '/forgotPassword',
          params: {userId: undefined},
          templateUrl: 'js/forgotPassword/forgotPassword.html' + appVersion,
          parent: 'main'
        })
        .state('challenges', {
          url: '/challenges',
          templateUrl: 'js/forgotPassword/challengeUser.html' + appVersion,
          parent: 'main'
        })
        .state('confirmPasswordReset', {
          url: '/confirmPasswordReset',
          templateUrl: 'js/forgotPassword/passwordResetLinkSent.html' + appVersion,
          parent: 'main'
        })
        .state('resetPassword', {
          url: '/resetPassword?id&guid',
          templateUrl: 'js/forgotPassword/resetPassword.html' + appVersion,
          parent: 'main'
        })
        .state('userProfile', {
          url: '/userProfile',
          'abstract': true,
          parent: 'main'
        })
        .state('userProfile.edit', {
          url: '/edit',
          templateUrl: 'js/userProfile/userProfile.html' + appVersion
        })
        .state('userProfile.changeCredential', {
          url: '/changeCredential',
          templateUrl: 'js/userProfile/changeCredential.html' + appVersion
        })
        .state('benefits', {
          url: '/benefits',
          'abstract': true
        })
        .state('lookup', {
          url: '/lookup',
          name: 'lookup',
          templateUrl: 'js/benefits/benefitsLookup.html' + appVersion,
          parent: 'main'
        })
        .state('benefits.dashboard', {
          url: '/:referenceId?subscriberId&dateOfBirth&expandAssociatedMembers&uuid&eligibilityAuditTS',
          templateUrl: 'js/benefits/dashboard.html' + appVersion
        })
        .state('admin', {
          url: '/admin',
          'abstract': true,
          parent: 'main'
        })
        .state('admin.users', {
          url: '/users',
          templateUrl: 'js/admin/userSearch.html' + appVersion
        })
        .state('dsoRequestConfirmation', {
          url: '/dsoRequestConfirmation',
          templateUrl: 'js/registration/dsoRequestConfirmation.html' + appVersion,
          parent: 'main'
        })
        .state('dsosLookup', {
          url: '/dsosLookup',
          templateUrl: 'js/dso/dsoLookup.html' + appVersion,
          parent: 'main'
        })
        .state('gat', {
          url: '/gat',
          templateUrl: 'js/admin/gatUpload.html' + appVersion,
          parent: 'main'
        })
        .state('faq', {
          url: '/faq',
          templateUrl: 'js/general/faq.html' + appVersion,
          parent: 'main'
        })
        .state('info', {
          url: '/info',
          templateUrl: 'js/general/info.html' + appVersion,
          parent: 'main'
        })
        .state('dsoAdmin', {
          url: '/dsoAdmin',
          'abstract': true,
          parent: 'main'
        })
        .state('dsoAdmin.users', {
          url: '/users',
          params: {refresh: ""},
          templateUrl: 'js/dso/dsoUserSearch.html' + appVersion
        })
        .state('dsoAdmin.corporateProfile', {
          url: '/corporateProfile',
          templateUrl: 'js/dso/corporateProfile.html' + appVersion
        })
        .state('dsoAdmin.corporateTaxIds', {
          url: '/corporateTaxIds',
          templateUrl: 'js/dso/corporateTaxIds.html' + appVersion
        })
        .state('claimsMain', {
          templateUrl: 'js/main.html' + appVersion
        })
        .state('claims', {
          parent: 'claimsMain',
          url: '/claims',
          sticky: true,
          templateUrl: 'js/claims/claims.html' + appVersion
        })
        .state('claimsSearch', {
          url: '/search/:referenceId',
          params: {
            referenceId: ""
          },
          parent: 'claims',
          sticky: true,
          views: {
               claimsSearch: {
                  templateUrl: 'js/claims/claimsSearch.html' + appVersion
               }
          }
         })
         .state('claimNav', {
                parent: 'claimsSearch'
         })
        .state('claimLines', {
          url: '/:claimId',
          parent: 'claims',
          sticky: true,
          views: {
            claimLines: {
              templateUrl: 'js/claims/claimSummaryView.html' + appVersion
            }
          }
        })
        .state('userHistory', {
          url: '/history',
          parent: 'main',
          templateUrl: 'js/userProfile/userHistory.html' + appVersion
        })
        .state('dsoProviderUser', {
          url: '/providerUser',
          templateUrl: 'js/dso/dsoProviderUser.html' + appVersion,
          parent: 'dsoAdmin',
          params: {user: {}, mode: ""}
        })
        .state('dsoAdminUser', {
          url: '/adminUser',
          templateUrl: 'js/dso/dsoAdminUser.html' + appVersion,
          parent: 'dsoAdmin',
          params: {user: {}, mode: "", selfView: false}
        })
      ;
    }]);
})();
